import { find, map } from 'lodash';
import Opportunity from '../opportunity/Opportunity';
import { opportunityTypes } from '../opportunity/Opportunity.enum';
import OrganizationFeatureClientPortal from './OrganizationFeatureClientPortal';
import OrganizationFeatureComms from './OrganizationFeatureComms';
import OrganizationFeatureEDocSignatures from './OrganizationFeatureEDocSignatures';
import OrganizationFeaturePartnerPortal from './OrganizationFeaturePartnerPortal';
import OrganizationFeatureIdSmart from './OrganizationFeatureIdSmart';
import OrganizationFeatureBasiq from './OrganizationFeatureBasiq';
import OrganizationFeaturePpsr from './OrganizationFeaturePpsr';
import type { IOrganizationFeatures } from './OrganizationFeatures.interface';

export default class OrganizationFeatures implements IOrganizationFeatures {
  useBasiq: boolean;
  useClientPortal: boolean;
  useComms: boolean;
  useDiversification: boolean;
  useEDocSignatures: boolean;
  useIdSmart: boolean;
  useMarketing: boolean;
  usePartnerPortal: boolean;
  usePpsr: boolean;
  useVideoConferencing: boolean;
  useWebloanQ: boolean;
  configBasiq: OrganizationFeatureBasiq;
  configClientPortal: OrganizationFeatureClientPortal;
  configDiversification: Array<Opportunity>;
  configEDocSignatures: OrganizationFeatureEDocSignatures;
  configIdSmart: OrganizationFeatureIdSmart;
  configPartnerPortal: OrganizationFeaturePartnerPortal;
  configPpsr: OrganizationFeaturePpsr;
  configSMS: OrganizationFeatureComms;

  hasBasiq() {
    return this.useBasiq;
  }

  hasClientPortal() {
    return this.useClientPortal;
  }

  hasComms() {
    return this.useComms;
  }

  hasDiversification() {
    return this.useDiversification;
  }

  hasEDocSignatures() {
    return this.useEDocSignatures;
  }

  hasIdSmart() {
    return this.useIdSmart;
  }

  hasMarketing() {
    return this.useMarketing;
  }

  hasPartnerPortal() {
    return this.usePartnerPortal;
  }

  hasPpsr() {
    return this.usePpsr;
  }

  hasVideoConferencing() {
    return this.useVideoConferencing;
  }

  hasWebloanQ() {
    return this.useWebloanQ;
  }

  static build = (data: IOrganizationFeatures) => new OrganizationFeatures(data);
  static blank = () => new OrganizationFeatures();

  /**
   * Constructor
   * @param {IOrganizationFeatures} data
   */
  constructor(data?: IOrganizationFeatures) {
    this.useBasiq = data?.useBasiq === true;
    this.useClientPortal = data?.useClientPortal === true;
    this.useComms = data?.useComms === true;
    this.useDiversification = data?.useDiversification === true;
    this.useEDocSignatures = data?.useEDocSignatures === true;
    this.useIdSmart = data?.useIdSmart === true;
    this.useMarketing = data?.useMarketing === true;
    this.usePartnerPortal = data?.usePartnerPortal === true;
    this.usePpsr = data?.usePpsr === true;
    this.useVideoConferencing = data?.useVideoConferencing === true;
    this.useWebloanQ = data?.useWebloanQ === true;
    this.configBasiq = new OrganizationFeatureBasiq(data?.configBasiq);
    this.configClientPortal = new OrganizationFeatureClientPortal(data?.configClientPortal);
    this.configDiversification = map(
      map(opportunityTypes, (opportunityType) => {
        const opportunity = find(
          data?.configDiversification,
          (cfg) => cfg.type.name === opportunityType
        );
        return opportunity || { type: { name: opportunityType } };
      }),
      (obj) => new Opportunity(obj)
    );
    this.configEDocSignatures = new OrganizationFeatureEDocSignatures(
      data?.configEDocSignatures
    );
    this.configIdSmart = new OrganizationFeatureIdSmart(data?.configIdSmart);
    this.configPartnerPortal = new OrganizationFeaturePartnerPortal(data?.configPartnerPortal);
    this.configPpsr = new OrganizationFeaturePpsr(data?.configPpsr);
    this.configSMS = new OrganizationFeatureComms(data?.configSMS);
  }
}
